import React, { useRef } from 'react';
import { Grid, Typography, Button } from '@mui/material';
import imgurl from './assests/images/imgurl';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import CameraAltOutlinedIcon from '@mui/icons-material/CameraAltOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import { useSelector, useDispatch } from 'react-redux'
import { useEffect, useState } from 'react';
import { replace, useLocation, useNavigate } from "react-router-dom";
import { setactiveview, setleftview } from './Reducers/reducer';
import Aloxa from './Aloxa';
import i18next from 'i18next';
import Sidebar from './components/Sidebar';
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";


function TakePhotoLeft({ capture }) {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const location = useLocation()

  const [webCamera, setWebCamera] = useState(false)
  const [capturedImg, setCapturedImg] = useState('https://res.cloudinary.com/dgeiynco8/image/upload/v1743413674/gifs/v0qarlguq4ytwuoch5bf.gif')
  const [radioValue, setRadioValue] = useState('yes')

  const Leftview = useSelector((state) => state.user.profile.Leftview);

  useEffect(() => {
    if(Leftview){
      setWebCamera(false)
    } else {
      setWebCamera(true)
    }
  }, [Leftview]); // Runs when "name" changes

  function enablecamera() {
    navigate('/headcapture')
    dispatch(setactiveview('Left'))
  }

  const takePhoto = () => {
    if(window.cordova){
      capture('capture', 'tutorial')
    } else {
      setWebCamera(true)
    }
  }

  const handleRadioChange = (value) => {
    setRadioValue(value)
    // dispatch(setmaskcontent(value))
    localStorage.setItem('maskconsent', value)
  }

  return (
    <div className="photo-container main-section-container take-photoSection">
      <Grid container spacing={0} className='d-flex justify-content-start align-items-center'>
        <Grid item xs={1} className=''>
          <div className='d-flex justify-content-start align-items-center'>

            <span className='backButtonDiv' onClick={() => navigate("/taketest", {state: {goTo: "taketest", user_obj: location?.state?.user_obj}})}>
              <ArrowBackOutlinedIcon className='arrowBackBtn'></ArrowBackOutlinedIcon>
            </span>
          </div>
        </Grid>
        <Grid item xs={10} className='d-flex justify-content-center align-items-center'>
          <Typography variant="h6" className="title">
            {i18next.t("Take a Photo")} - {i18next.t("Left")}
          </Typography>
        </Grid>
        <Grid item xs={1}>
          <Sidebar />
        </Grid>
      </Grid>
      <Grid container spacing={0} className='d-flex align-items-center justify-content-center flex-direction-column mt-5px'>
        <Grid item xs={12} className='d-flex justify-content-center align-items-center flex-direction-column'>
          {/* <p className='mainHeading'>Left</p> */}
          {/* <Typography variant="h6" className='subHeading'>
            {i18next.t("Position your face in front of the camera and face right to capture your left profile.")}
          </Typography> */}
          <div className='leftPhotoImg selfScanPhotoImg'>
            {
              webCamera ? 
                <Aloxa selfScan={true} selfScanLeft={true} userObj={location?.state?.user_obj}/>
                 : 
                Leftview ? 
                 <img src={"data:image/jpeg;base64," + Leftview}/> 
                   : 
                //  <img src={capturedImg}/>
                ""
            }
          </div>
          {
            Leftview && !webCamera ?
            <>
              {/* <div className="questionsSectionDiv mt-5px">
                <Typography>Is your face masked?</Typography>

                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue={localStorage.getItem('maskconsent') != '' ? localStorage.getItem('maskconsent') : radioValue}
                  name="radio-buttons-group"
                  onChange={(e) => handleRadioChange(e.target.value)}
                >
                  <FormControlLabel
                    value="yes"
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
              </div> */}
              <Button variant="contained" className='commonButton d-flex justify-content-center align-items-center gap-10px mt-20px' onClick={() => takePhoto()}>
                <CameraAltOutlinedIcon></CameraAltOutlinedIcon>
                {i18next.t("Retake Photo")}
              </Button>
             </>  :
              !webCamera ? 
              // <Button variant="contained" className='commonButton mt-20px d-flex justify-content-center align-items-center gap-10px mt-20px' onClick={() => takePhoto()}>
              //   <CameraAltOutlinedIcon></CameraAltOutlinedIcon>
              //   {i18next.t("Take")}  <span>{i18next.t("a")}</span>  {i18next.t("Photo")}
              // </Button> 
              ''
                : 
              ''
          }
          {/* <Button variant="contained" className='commonButton d-flex justify-content-center align-items-center gap-10px' onClick={() => capture('upload', 'tutorial')}>
            <CloudUploadOutlinedIcon></CloudUploadOutlinedIcon>
            Upload<span>from</span>Gallery</Button> */}
        </Grid>
      </Grid>

    </div>
  )
}

export default TakePhotoLeft